import { createActionsGroup } from 'utils/redux-utils'

export const sendNewsletterFeedbackActions = createActionsGroup(
  'NEWSLETTER.FEEDBACK',
)
